import React from 'react';
import ImportReviewPage from '../ImportReviewPage';

/**
 * Review tab — Import Review rendered inside the ETL Configuration frame.
 *
 * Still the original component; `embedded` drops its duplicate page title and
 * outer container so it sits under the shared head band. Its internals are
 * converted to the kit in a later pass.
 */
export default function ReviewTab() {
  return <ImportReviewPage embedded />;
}
